import React from "react";
import Preloader from "../../helper/Preloader";
import ColorInit from "../../helper/ColorInit";
import RegisterForm from "../../components/auth/RegisterForm";

const RegisterPage = () => {



  return (
    <>
      {/* ColorInit */}
      <ColorInit color={false} />

      {/* Preloader */}
      <Preloader />

      <RegisterForm />
    </>
  );
};

export default RegisterPage;
